export const matchPriceOrDash = (price: number) => (price ? `${price}k` : '-');
